import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function FilterIcon2(props: IconProps) {
  const styles = { ...props.style, transform: 'rotate(180deg)' };
  return (
    <SvgIcon {...props} style={styles}>
    <path d="M10 12.261 4.028 3.972h16L14 12.329V17l-4 3z"/>    
  </SvgIcon>
  );
}


